// src/service/ImportantInfoService.js

const getImportantInfos = async (user) => {
    if (!user || !user.type) {
        return [];
    }

    // Retourner les informations importantes en fonction du type d'utilisateur
    if (user.type === "agence_admin") {
        return [{ code: "CC" }];
    } else if (user.type === "collaborateur") {
        return [{ code: "DD" }];
    }

    return [];
};

export default {
    getImportantInfos,
};